export const DEAL_TONES = {
  red: {
    card: 'border-red-200 bg-red-50',
    price: 'text-red-700',
    badge: 'bg-red-100 text-red-800',
  },
  orange: {
    card: 'border-orange-200 bg-orange-50',
    price: 'text-orange-700',
    badge: 'bg-orange-100 text-orange-800',
  },
  green: {
    card: 'border-emerald-200 bg-emerald-50',
    price: 'text-emerald-700',
    badge: 'bg-emerald-100 text-emerald-800',
  },
  neutral: {
    card: 'border-gray-200 bg-gray-50',
    price: 'text-gray-800',
    badge: 'bg-gray-100 text-gray-700',
  },
}

const formatDealPercent = (value) => `${Math.abs(value).toLocaleString('cs-CZ', { maximumFractionDigits: 1 })} %`

export const getFloorDealComparison = (askingPrice, floorPrice) => {
  if (!Number.isFinite(Number(askingPrice)) || Number(askingPrice) <= 0 || !Number.isFinite(Number(floorPrice)) || Number(floorPrice) <= 0) return null
  const gapPercent = ((Number(floorPrice) - Number(askingPrice)) / Number(floorPrice)) * 100
  return {
    gapPercent,
    tone: gapPercent >= 5 ? 'green' : gapPercent >= 0 ? 'orange' : 'red',
    label:
      gapPercent >= 0
        ? `Nabídka je ${formatDealPercent(gapPercent)} pod spodní hranicí odhadu`
        : `Nabídka je ${formatDealPercent(gapPercent)} nad spodní hranicí odhadu`,
    shortLabel:
      gapPercent >= 0
        ? `${formatDealPercent(gapPercent)} pod spodní hranicí`
        : `${formatDealPercent(gapPercent)} nad spodní hranicí`,
  }
}

export const getRenovatedDealComparison = (askingPrice, renovatedPrice) => {
  if (!Number.isFinite(Number(askingPrice)) || Number(askingPrice) <= 0 || !Number.isFinite(Number(renovatedPrice)) || Number(renovatedPrice) <= 0) return null
  const gapPercent = ((Number(renovatedPrice) - Number(askingPrice)) / Number(askingPrice)) * 100
  return {
    gapPercent,
    tone: gapPercent >= 20 ? 'green' : gapPercent >= 10 ? 'orange' : 'red',
    label: gapPercent >= 0 ? `Prostor do ceny po rekonstrukci: +${formatDealPercent(gapPercent)}` : `Nabídka je nad odhadem po rekonstrukci o ${formatDealPercent(gapPercent)}`,
    shortLabel: gapPercent >= 0 ? `+${formatDealPercent(gapPercent)} prostor` : `${formatDealPercent(gapPercent)} nad odhadem`,
  }
}

export const getDealTone = (comparison) => DEAL_TONES[comparison?.tone] || DEAL_TONES.neutral
